<script setup lang="ts">
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import type { PropType } from "vue";
import { dialogPt } from "./style.ts";

defineProps({
  visible: { type: Boolean, required: true },
  title: { type: String },
  message: { type: String },
});

const emit = defineEmits(["update:visible", "confirm", "cancel"]);
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    :header="title"
    :pt="dialogPt"
  >
   <div class="flex items-start gap-2">
      <span class="material-icons-outlined text-3xl text-orange-500">warning_amber</span>
      <p class="m-0">{{ message }}</p>
    </div>
    <div class="flex justify-end gap-2 mt-4">
      <Button label="No" @click="emit('cancel')" />
      <Button label="Yes" @click="emit('confirm')" severity="danger" />
    </div>
  </Dialog>
</template>
